import React from "react"
import { valrops } from "components/ui/utils"

interface props {
    data?: valrops
    dataColor?: any
}

function ValueIcon({ data, dataColor = "#333" }: props): JSX.Element  {
    if (!data) {
            return (
                <>
                    <line x1="32" y1="18" x2="32" y2="46" stroke="#333" stroke-width="2"/>
                    <circle cx="28" cy="32" r="2" fill="#333"/>
                    <circle cx="36" cy="32" r="2" fill="#333"/>
                </>
        )
    }

    const textColor = data?.color ? data.color : dataColor
  
    return <text x="14" y="36" font-family="Arial" font-size="6" fill={textColor} font-weight="bold">{data.text}</text>
}

function ShrpIcon(props: React.PropsWithChildren<React.SVGProps<SVGSVGElement>> & props): JSX.Element  {
    return (
        <svg
            width="64"
            height="64"
            viewBox="0 0 64 64"
            fill="none"
            className="grp"
            xmlns="http://www.w3.org/2000/svg"
        >
            <rect x="12" y="18" width="40" height="28" rx="2" fill="#FFD700" stroke="#333" stroke-width="2"/>

            <rect x="6" y="28" width="6" height="8" fill="#32CD32" stroke="#333" stroke-width="2"/>
            <circle cx="9" cy="32" r="2" fill="#333"/>

            <rect x="52" y="28" width="6" height="8" fill="#32CD32" stroke="#333" stroke-width="2"/>
            <circle cx="55" cy="32" r="2" fill="#333"/>

            <rect x="10" y="46" width="44" height="4" fill="#666" stroke="#333" stroke-width="2"/>

            <ValueIcon {...props} />
      </svg>
    )
}

export default ShrpIcon
